export default "https://cdn-gra-staging.amplement.io/statics/images/placeholder/placeholderContact@2x.png";